export default __webpack_public_path__ + "static/media/review.1eabeb34.png";